// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8m-4";
export var collapsed = "_8m-1";
export var headerBar = "_8m-0";
export var leftHeaderContent = "_8m-3";
export var subjectContainer = "_8m-2";